export function compact(collection) {
  if (Array.isArray(collection)) return collection.filter(Boolean)
  const newObject = {}
  Object.entries(collection).map(([key, value]) => {
    if (value) {
      newObject[key] = value
    }
  })
  return newObject
}
